export const HEIGHTS = {
  HD: 720,
  fullHD: 1080,
  UHD: 2160,
};
